const getVideoThumbnailUrl = (video) => {
  if (!video) {
    return null;
  }

  if (video.type === 'youtube') {
    return `https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`;
  }

  return `https://vumbnail.com/${video.id}.jpg`;
};

export const getItemMedia = ({
  contentMediaType,
  contentMediaImage,
  contentMediaVideo,
  backgroundMediaType,
  backgroundMediaImage,
  backgroundMediaVideo,
  contentMediaEnabled,
  type,
  background,
  image,
  video,
  elements
}) => {
  if (type === 'image-slide') {
    return image?.url;
  }

  if (type === 'video-slide') {
    return getVideoThumbnailUrl(video);
  }

  if (type === 'slide-builder') {
    const mediaElements = elements?.filter(
      ({ type, src }) => (type === 'image' || type === 'video') && src
    );

    if (mediaElements?.length) {
      const [mainMedia] = mediaElements;

      if (mainMedia.type === 'image') {
        return mainMedia.src.url;
      }

      if (mainMedia.type === 'video') {
        return getVideoThumbnailUrl(mainMedia.src);
      }
    }

    if (background?.type === 'image' && background?.imageFile) {
      return background.imageFile.url;
    }

    if (background?.type === 'video' && background?.videoUrl) {
      return getVideoThumbnailUrl(background.videoUrl);
    }

    return null;
  }

  const contentImage =
    contentMediaType === 'image'
      ? contentMediaImage?.url
      : getVideoThumbnailUrl(contentMediaVideo);
  const backgroundImage =
    backgroundMediaType === 'image'
      ? backgroundMediaImage?.url
      : getVideoThumbnailUrl(backgroundMediaVideo);

  return contentMediaEnabled && contentImage ? contentImage : backgroundImage;
};
